import React from 'react';
import styled from 'styled-components';

interface Props {
  title: string;
  value: React.ReactNode;
  color: string;
  icon?: React.ReactNode;
}

export const StatCardsRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
`;

const Card = styled.div<{ $color: string }>`
  flex: 1;
  min-width: 200px;
  background: var(--surface-color);
  border: 1px solid var(--border-color);
  border-right: 3px solid ${p => p.$color};
  border-radius: var(--border-radius-md);
  padding: 16px 20px;

  @media (max-width: 767px) {
    min-width: 100%;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
`;

const Title = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary);
`;

const Icon = styled.div<{ $color: string }>`
  color: ${p => p.$color};
  opacity: 0.5;
  display: flex;
`;

const Value = styled.div<{ $color: string }>`
  font-size: 26px;
  font-weight: 700;
  color: ${p => p.$color};
  direction: ltr;
  text-align: right;

  @media (max-width: 767px) {
    font-size: 22px;
  }
`;

const StatCard: React.FC<Props> = ({ title, value, color, icon }) => (
  <Card $color={color}>
    <Header>
      <Title>{title}</Title>
      {icon && <Icon $color={color}>{icon}</Icon>}
    </Header>
    <Value $color={color}>{value}</Value>
  </Card>
);

export default StatCard;
